import React from "react";
import Slider from "../component/slider";
import Category from "../component/category";
import CategoryFooter from "../component/CategoryFooter";
import FreeShipping from "../component/freeshipping";
//import Banners from "../component/Banners";
//import WelcomeModal from "../component/WelcomeModal";

function Home()
{
    return(
        <>
        <Slider />
        <Category />
        <FreeShipping />
        <CategoryFooter />
        {/*<Banners />*/}
        {/*<WelcomeModal />*/}
        </>
    );
}
export default Home;